export const getWindowSizes = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;

  return {
    width,
    height,
  };
};
